import i18n from '@/locales'

/** 根据路由 meta.titleKey 同步浏览器标题 */
export function syncDocumentTitle (to) {
  if (!to?.meta) return
  const titleKey = to.meta.titleKey
  const pageTitle = titleKey
    ? i18n.global.t(titleKey)
    : to.meta.title
  if (pageTitle) {
    document.title = `${pageTitle} - ${i18n.global.t('common.appName')}`
  }
}

/** 语言切换后刷新当前页标题 */
export function syncDocumentTitleFromRoute () {
  if (typeof window === 'undefined') return
  // 延迟加载 router，避免与 router/index 循环依赖
  import('@/router').then(({ default: router }) => {
    syncDocumentTitle(router.currentRoute.value)
  })
}
